export default "__VITE_ASSET__D2tPL0pH__"